import { getContrastingTextColor } from "../../../util/ColorUtil";

const UserIcon = ({ initials, iconColor, ...rest }) => {
  const defaultColor = "#cccccc";
  const safeIconColor = iconColor || defaultColor;

  return (
    <div
      className="user-icon"
      style={{
        color: getContrastingTextColor(safeIconColor),
        backgroundColor: safeIconColor,
      }}
      {...rest}
    >
      {initials}
    </div>
  );
};

export default UserIcon;
